import { useSelector } from "react-redux";
import {
  selectSelectedElement,
  updateSelectedInteraction,
} from "../../../app/slices/TrainingSlice";
import { IClearCharacterParts } from "../../../models/interactions/ClearCharacterParts";
import { useDispatch } from "react-redux";
import ActorPropDropdown from "../lookat/ActorPropDropdown";
import CharacterPartSelectionList from "./CharacterPartSelectionList";
import { CharacterPartType } from "../../../dto/CharacterPartDTO";

export default function ClearCharacterPartsPreviewBody() {
  const dispatch = useDispatch();
  const interaction = useSelector(
    selectSelectedElement
  ) as IClearCharacterParts;

  const updateInteraction = (field: keyof IClearCharacterParts, value: any) => {
    dispatch(
      updateSelectedInteraction({
        ...interaction,
        [field]: value,
      })
    );
  };

  const onToggleCharacterPart = (part: CharacterPartType, toggled: boolean) => {
    const cpy = [...interaction.partsToClear];
    if (toggled) {
      cpy.push(part);
    } else {
      cpy.splice(cpy.indexOf(part), 1);
    }
    updateInteraction("partsToClear", cpy);
  };

  // 1. actor dropdown
  const actorDropdown = (
    <ActorPropDropdown
      label="Target"
      onClick={(id) => updateInteraction("npcId", id)}
      selectedObjectId={interaction.npcId}
    />
  );

  // 2. list
  const list = (
    <div className="flex flex-col w-full h-full gap-[8px]">
      <div className={"text-base font-bold text-interaction-primary h-[30px]"}>
        Character Parts
      </div>
      <CharacterPartSelectionList
        selectedParts={interaction.partsToClear}
        onToggleCharacterPart={onToggleCharacterPart}
      />
    </div>
  );

  return (
    <div className="flex flex-col w-full h-full gap-[12px]">
      {actorDropdown}
      {list}
    </div>
  );
}
